export default {
    data(){
        return {
            coursesFromApi: [
                {
                    "id": 2150,
                    "codigo": "LEIE01",
                    "name": "Lenguaje Intensivo Egresado 1",
                    "capacidad": 30,
                    "cupo": 0,
                    "comun": false,
                    "subject": {
                        "id": 1,
                        "name": "Lenguaje"
                    },
                    "schedule": [{
                            "id": 5334,
                            "bloque": 2,
                            "horaDesde": "10:00:00",
                            "horaHasta": "11:20:00",
                            "dia": "Lunes"
                        },
                        {
                            "id": 5336,
                            "bloque": 2,
                            "horaDesde": "10:00:00",
                            "horaHasta": "11:20:00",
                            "dia": "Miércoles"
                        },
                        {
                            "id": 5337,
                            "bloque": 2,
                            "horaDesde": "10:00:00",
                            "horaHasta": "11:20:00",
                            "dia": "Jueves"
                        },
                    ]
                },
                {
                    "id": 2153,
                    "codigo": "LEIE01",
                    "name": "Fiísica",
                    "capacidad": 30,
                    "cupo": 0,
                    "comun": false,
                    "subject": {
                        "id": 2,
                        "name": "Física"
                    },
                    "schedule": [{
                            "id": 5334,
                            "bloque": 2,
                            "horaDesde": "10:00:00",
                            "horaHasta": "11:20:00",
                            "dia": "Lunes"
                        },
                        {
                            "id": 5336,
                            "bloque": 2,
                            "horaDesde": "10:00:00",
                            "horaHasta": "11:20:00",
                            "dia": "Miércoles"
                        },
                        {
                            "id": 5337,
                            "bloque": 2,
                            "horaDesde": "10:00:00",
                            "horaHasta": "11:20:00",
                            "dia": "Jueves"
                        },
                    ]
                },
                {
                    "id": 2156,
                    "codigo": "LEIE01",
                    "name": "Física",
                    "capacidad": 30,
                    "cupo": 0,
                    "comun": false,
                    "hasMention": true,
                    "subject": {
                        "id": 3,
                        "name": "Física Mención"
                    },
                    "schedule": [{
                            "id": 5334,
                            "bloque": 2,
                            "horaDesde": "10:00:00",
                            "horaHasta": "11:20:00",
                            "dia": "Lunes"
                        },
                        {
                            "id": 5336,
                            "bloque": 2,
                            "horaDesde": "10:00:00",
                            "horaHasta": "11:20:00",
                            "dia": "Miércoles"
                        },
                        {
                            "id": 5337,
                            "bloque": 2,
                            "horaDesde": "10:00:00",
                            "horaHasta": "11:20:00",
                            "dia": "Jueves"
                        },
                    ]
                },
                {
                    "id": 2151,
                    "codigo": "LEIE01",
                    "name": "Matemática",
                    "capacidad": 30,
                    "cupo": 0,
                    "comun": false,
                    "subject": {
                        "id": 10,
                        "name": "Matemática"
                    },
                    "schedule": [{
                            "id": 5334,
                            "bloque": 2,
                            "horaDesde": "10:00:00",
                            "horaHasta": "11:20:00",
                            "dia": "Lunes"
                        },
                        {
                            "id": 5336,
                            "bloque": 2,
                            "horaDesde": "10:00:00",
                            "horaHasta": "11:20:00",
                            "dia": "Miércoles"
                        },
                        {
                            "id": 5337,
                            "bloque": 2,
                            "horaDesde": "12:00:00",
                            "horaHasta": "13:20:00",
                            "dia": "Jueves"
                        },
                    ]
                },
                {
                    "id": 2154,
                    "codigo": "LEIE01",
                    "name": "Biología",
                    "capacidad": 30,
                    "cupo": 0,
                    "comun": false,
                    "subject": {
                        "id": 4,
                        "name": "Biología"
                    },
                    "schedule": [{
                            "id": 5334,
                            "bloque": 2,
                            "horaDesde": "10:00:00",
                            "horaHasta": "11:20:00",
                            "dia": "Lunes"
                        },
                        {
                            "id": 5336,
                            "bloque": 2,
                            "horaDesde": "10:00:00",
                            "horaHasta": "11:20:00",
                            "dia": "Miércoles"
                        },
                        {
                            "id": 5337,
                            "bloque": 2,
                            "horaDesde": "10:00:00",
                            "horaHasta": "11:20:00",
                            "dia": "Jueves"
                        },
                    ]
                },
                {
                    "id": 2157,
                    "codigo": "LEIE01",
                    "name": "Biología",
                    "capacidad": 30,
                    "cupo": 0,
                    "comun": false,
                    "hasMention": true,
                    "subject": {
                        "id": 6,
                        "name": "Biología Mención"
                    },
                    "schedule": [{
                            "id": 5334,
                            "bloque": 2,
                            "horaDesde": "10:00:00",
                            "horaHasta": "11:20:00",
                            "dia": "Lunes"
                        },
                        {
                            "id": 5336,
                            "bloque": 2,
                            "horaDesde": "10:00:00",
                            "horaHasta": "11:20:00",
                            "dia": "Miércoles"
                        },
                        {
                            "id": 5337,
                            "bloque": 2,
                            "horaDesde": "10:00:00",
                            "horaHasta": "11:20:00",
                            "dia": "Jueves"
                        },
                    ]
                },
                {
                    "id": 2152,
                    "codigo": "LEIE01",
                    "name": "Ciencias Sociales",
                    "capacidad": 30,
                    "cupo": 0,
                    "comun": false,
                    "subject": {
                        "id": 7,
                        "name": "Ciencias Sociales"
                    },
                    "schedule": [{
                            "id": 5334,
                            "bloque": 2,
                            "horaDesde": "10:00:00",
                            "horaHasta": "11:20:00",
                            "dia": "Lunes"
                        },
                        {
                            "id": 5336,
                            "bloque": 2,
                            "horaDesde": "10:00:00",
                            "horaHasta": "11:20:00",
                            "dia": "Miércoles"
                        },
                        {
                            "id": 5337,
                            "bloque": 2,
                            "horaDesde": "10:00:00",
                            "horaHasta": "11:20:00",
                            "dia": "Jueves"
                        },
                    ]
                },
                {
                    "id": 2155,
                    "codigo": "LEIE01",
                    "name": "Química",
                    "capacidad": 30,
                    "cupo": 0,
                    "comun": false,
                    "subject": {
                        "id": 8,
                        "name": "Química"
                    },
                    "schedule": [{
                            "id": 5334,
                            "bloque": 2,
                            "horaDesde": "10:00:00",
                            "horaHasta": "11:20:00",
                            "dia": "Lunes"
                        },
                        {
                            "id": 5336,
                            "bloque": 2,
                            "horaDesde": "10:00:00",
                            "horaHasta": "11:20:00",
                            "dia": "Miércoles"
                        },
                        {
                            "id": 5337,
                            "bloque": 2,
                            "horaDesde": "10:00:00",
                            "horaHasta": "11:20:00",
                            "dia": "Jueves"
                        },
                    ]
                },
                {
                    "id": 2158,
                    "codigo": "LEIE01",
                    "name": "Química",
                    "capacidad": 30,
                    "cupo": 0,
                    "comun": false,
                    "hasMention": true,
                    "subject": {
                        "id": 9,
                        "name": "Química Mención"
                    },
                    "schedule": [{
                            "id": 5334,
                            "bloque": 2,
                            "horaDesde": "10:00:00",
                            "horaHasta": "11:20:00",
                            "dia": "Lunes"
                        },
                        {
                            "id": 5336,
                            "bloque": 2,
                            "horaDesde": "10:00:00",
                            "horaHasta": "11:20:00",
                            "dia": "Miércoles"
                        },
                        {
                            "id": 5337,
                            "bloque": 2,
                            "horaDesde": "10:00:00",
                            "horaHasta": "11:20:00",
                            "dia": "Jueves"
                        },
                    ]
                },
            ],
            allSubjects:[
                'Lenguaje',
                'Matemática',
                'Ciencias Sociales',
                'Física',
                'Biología',
                'Química',
                'Física Mención',
                'Biología Mención',
                'Química Mención',
                'Matemática Electivo'
            ],
            unavailableSubjects:[],
            courses: [],
            disableButton: true,
            ErrorSubmit: false,
            subjectsOrder: {
                'Lenguaje': 1,
                'Matemática': 2,
                'Ciencias Sociales': 3,
                'Física': 4,
                'Biología': 5,
                'Química': 6,
                'Física Mención': 7,
                'Biología Mención': 8,
                'Química Mención': 9
            }
        }
    },
    methods: {
       refactorCourses() {

            let coursesSubjects = this.coursesFromApi.map(course => {
                
                course = {
                    id: course.Subject.id,
                    name: course.Subject.name,
                    subject: course.Subject,
                    hasMention: course.hasMention,
                    disabled: false
                };

                this.$set(course, 'checked', false);

                if (course.subject.name === 'Lenguaje') {
                    course.iconSrc = '/images/iconos/languaje.svg';
                    course.color = '#135FAB';
                    this.$set(course, 'displayName', 'Lenguaje');

                } else if (course.subject.name === 'Química') {
                    course.iconSrc = '/images/iconos/quimica.svg';
                    course.color = '#652467';
                    course.common = true;
                    this.$set(course, 'displayName', 'Química');

                } else if (course.subject.name === 'Matemática') {
                    course.iconSrc = '/images/iconos/maths.svg';
                    course.color = '#E6352B';
                    this.$set(course, 'displayName', 'Matemática (M2)');

                } else if (course.subject.name === 'Física') {
                    course.iconSrc = '/images/iconos/fisica.svg';
                    course.color = '#A1BC2D';
                    course.common = true;
                    this.$set(course, 'displayName', 'Física');

                } else if (course.subject.name === 'Ciencias Sociales') {
                    course.iconSrc = '/images/iconos/sociales.svg';
                    course.color = '#ED7820';
                    this.$set(course, 'displayName', 'Ciencias Sociales');

                } else if (course.subject.name === 'Biología') {
                    course.iconSrc = '/images/iconos/biologia.svg';
                    course.color = '#118A3F';
                    course.common = true;
                    this.$set(course, 'displayName', 'Biología');

                } else if (course.subject.name === 'Ciencias Sociales Mención') {
                    course.iconSrc = '/images/iconos/sociales.svg';
                    course.color = '#ED7820';
                    this.$set(course, 'displayName', 'Ciencias Sociales');

                } else if (course.subject.name === 'Biología Mención') {
                    course.iconSrc = '/images/iconos/biologia.svg';
                    course.color = '#118A3F';
                    this.$set(course, 'displayName', 'Biología');

                } else if (course.subject.name === 'Física Mención') {
                    course.iconSrc = '/images/iconos/fisica.svg';
                    course.color = '#A1BC2D';
                    this.$set(course, 'displayName', 'Física');

                } else if (course.subject.name === 'Lenguaje Mención') {
                    course.iconSrc = '/images/iconos/languaje.svg';
                    course.color = '#135FAB';
                    this.$set(course, 'displayName', 'Lenguaje');

                } else if (course.subject.name === 'Matemática Mención') {
                    course.iconSrc = '/images/iconos/maths.svg';
                    course.color = '#E6352B';
                    this.$set(course, 'displayName', 'Matemática');

                } else if (course.subject.name === 'Química Mención') {
                    course.iconSrc = '/images/iconos/quimica.svg';
                    course.color = '#652467';
                    this.$set(course, 'displayName', 'Química');

                } else {
                    course.iconSrc = '/images/iconos/fisica.svg';
                    course.color = '#A1BC2D';
                    this.$set(course, 'displayName', 'Undefined');
                }

                return course;
            });

            this.courses = [];
            coursesSubjects.forEach(course => {
                let itemInArray = this.courses.find(item => item.name === course.name);
                if (!itemInArray) {
                    this.courses.push(course);
                }
            });

            this.courses.sort((a, b) => {
                let name1 = a.name;
                let name2 = b.name;
                return this.subjectsOrder[name1] - this.subjectsOrder[name2];
            });

            let availableSubjectsNames = [];
            this.courses.forEach(course => {
                let itemInArray = availableSubjectsNames.find(subject => subject === course.name);
                if (!itemInArray) {
                    availableSubjectsNames.push(course.name);
                }
            });


            this.unavailableSubjects = this.allSubjects.filter(subject => {
                return !availableSubjectsNames.includes(subject)
            });

        }
    },
    mounted(){
    }
};
  